import { useLocation } from "@reach/router";
import React from "react";
import useEventDetails from "../../hooks/useEventDetails";
import { useModalStore } from "../../store/useModalStore";
import EmailLink from "../links/EmailLink";
import LoginSection from "../section/login";
import RegistrationSection from "../section/registration";
import { LoginModalWrapper } from "../styled";
import Modal from "./modal";

const LoginModal = () => {
  const { opened, isClosable, closeModal } = useModalStore();
  const { virtual } = useEventDetails();

  const handleOnClose = () => {
    isClosable && closeModal();
  };

  return (
    <Modal open={opened} onClose={handleOnClose}>
      <LoginModalWrapper>
        <div className={virtual ? "brandingReg virtual" : "brandingReg"}></div>
        <section>
          <LoginSection />
          <RegistrationSection />
          <EmailLink
            title="Get assistance"
            label="Help! Need Assistance?"
            email="events@scoopnewsgroup.com"
            subject="Google Public Sector Forum - Login/Registration Help"
            className="assistance footer"
          />
        </section>
      </LoginModalWrapper>
    </Modal>
  );
};

export default LoginModal;
